import { useMutation, UseMutationOptions, useQueryClient } from 'react-query'
import { useRouter } from 'next/router'
import { AxiosError } from 'axios'
import { useDispatch } from 'react-redux'

import {
  pushDangerNotification,
  pushSuccessNotification,
  useTranslation
} from '@plandi/common'
import { questionsApi } from './questions.api'
import { components } from '@plandi/common/src/generated'
import { removeEmptyFilterOptions } from '../filters'

export const useMutationLike = (
  options?: UseMutationOptions<
    unknown,
    AxiosError,
    components['schemas']['FaqRequest']
  >
) => {
  const queryClient = useQueryClient()
  const router = useRouter()
  const query = removeEmptyFilterOptions(router.query)
  const { data: translate } = useTranslation()
  const dispatch = useDispatch()
  const mutation = useMutation(
    async (requestBody) =>
      await questionsApi.createLike(requestBody, router.locale),
    {
      onSuccess: () => {
        dispatch(
          pushSuccessNotification(translate?.['blog-site']?.['reply-sent'])
        )
        queryClient.invalidateQueries(['Queries', query, router.locale])
      },
      onError: () => {
        dispatch(pushDangerNotification(translate?.['blog-site']?.error))
      },
      ...options
    }
  )

  return mutation
}
